module.exports = __webpack_public_path__ + "img/banner.329ab8a5.jpeg";